import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { DiscoveryApiPort } from './ports/discovery-api.port';
import { AdessoDiscoveryApiAdapter } from './adapters/adesso-discovery-api.adapter';

/**
 * Provides DiscoveryApiPort backed by the adesso-connector-api adapter.
 */
export function provideDiscoveryApi(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: DiscoveryApiPort, useClass: AdessoDiscoveryApiAdapter }
  ]);
}
